import { useShallow } from "zustand/react/shallow";

import { useModalStore } from "@krea/customer-features/store/modal/hooks";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

const Dialog = () => {
  const {
    modal,
    isOpen,
    closeOnBackgroundClick,
    onCloseSideEffects,
    closeModal,
  } = useModalStore(
    useShallow((state) => {
      const {
        modal,
        isOpen,
        closeOnBackgroundClick,
        onCloseSideEffects,
        closeModal,
      } = state;

      return {
        modal,
        isOpen,
        closeOnBackgroundClick,
        onCloseSideEffects,
        closeModal,
      };
    }),
  );

  const onCloseModal = () => {
    if (closeOnBackgroundClick) {
      closeModal();

      if (onCloseSideEffects) {
        onCloseSideEffects();
      }
    }
  };

  return (
    <div
      aria-hidden="true"
      onClick={onCloseModal}
      className={twMerge(
        "tw-top-0 tw-left-0 tw-bg-background/80 tw-invisible tw-opacity-0 tw-z-[1000]",
        "tw-flex tw-items-center tw-justify-center tw-fixed tw-p-6 tw-h-full tw-w-full",
        { "tw-opacity-100 tw-visible tw-delay-0": isOpen },
      )}
      style={{ transition: "opacity 0.3s ease 0s, visibility 0s ease 0.3s" }}
    >
      <div
        aria-hidden="true"
        onClick={(e) => e.stopPropagation()}
        className={twMerge(
          "tw-max-w-xl tw-transition-transform tw-shadow-xl",
          "tw-flex tw-flex-col tw-bg-white tw-rounded tw-max-h-full tw-w-full tw-relative tw-overflow-hidden tw-scale-100",
        )}
      >
        {modal}
      </div>
    </div>
  );
};

export default Dialog;
